import { render, staticRenderFns } from "./AddGeoRevenue.vue?vue&type=template&id=179e9f60&scoped=true&"
import script from "./AddGeoRevenue.vue?vue&type=script&lang=js&"
export * from "./AddGeoRevenue.vue?vue&type=script&lang=js&"
import style0 from "./AddGeoRevenue.vue?vue&type=style&index=0&id=179e9f60&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "179e9f60",
  null
  
)

export default component.exports